import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
} from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import ConfirmAction from '../../common/ConfirmAction';
import Input from '../../common/Input';
import TextArea from '../../common/TextArea';
import Currency from '../../common/Currency';
import ReactSelectWrapper from '../../common/ReactSelectWrapper';
import '../../css/forms/default-forms.css';
import { fields } from './fields';
import { processFields } from '../../utils/prePost';
import { validateFields } from '../../utils/validate';
import { updateMaterial, getMaterial, deleteMaterial } from '../../api/materials';
import { getVendorsList } from '../../api/vendors';
import { linkDataToFields } from '../../utils/fields';
import hasAccess from "../../helpers/permissionChecker";
import { changeModalState } from '../../actions/modal';
import { deleteObject } from '../../actions/objectToDelete';

export class MaterialEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: clone(fields),
    };
    this.submit = this.submit.bind(this);
    this.delete = this.delete.bind(this);
    this.cancel = this.cancel.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.fetchDataRouteById = this.fetchDataRouteById.bind(this);
  }

  fetchDataRouteById() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.getDataById(id);
  }

  componentDidMount() {
    this.fetchDataRouteById();
    this.props.getVendors();
  }

  componentDidUpdate(prevProps, prevState) {
    const currentMaterial = path(['materials', 'currentMaterial'], this.props);

    if (currentMaterial && currentMaterial !== prevProps.materials.currentMaterial) {
      const fields = linkDataToFields(
        currentMaterial,
        this.state.fields,
        null,
      );

      this.setState({ fields: fields });
    }
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      const processedData = processFields(this.state.fields);
      const id = path(['match', 'params', 'id'], this.props);
      this.props.saveForm(id, processedData);
    }
    return false;
  }

  delete() {
    const id = path(['match', 'params', 'id'], this.props);

    this.props.handleObjectToDelete({
      id: parseInt(id),
      handler: deleteMaterial,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'deleteMaterial',
    });
  }

  cancel() {
    this.props.redirectToMaterials();
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  getVendorsOptions() {
    const vendorsList = path(['vendors', 'list'], this.props) || [];
    return vendorsList.map((vendor) => ({
      value: vendor.id,
      label: vendor.name,
    }));
  }

  render() {
    const hasAccessForEdit = hasAccess({
      'permAreaKey': 'materials_inventory',
      'permTypeKey': 'edit',
    });
    const hasAccessForDelete = hasAccess({
      'permAreaKey': 'materials_inventory',
      'permTypeKey': 'delete',
    });
    const disableFieldForEdit = !hasAccessForEdit;
    return (
      <div>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { url: '/pages/materials', icon: 'shopping_cart', name: 'Materials' },
          { icon: 'edit', name: 'Edit Material' },
        ]} />
        <div className="card rounded">
          <div className="card-header rounded-top">
            <b>Edit Material</b>
          </div>
          <div className="card-block">
            <div className="col" style={{ paddingBottom: '40px' }}>
              <button className={'btn btn-danger btn-outline pull-right ml-3'} onClick={this.cancel}>
                <i className="fa fa-remove"></i>
                <span className="pl-1">Cancel</span>
              </button>
              {hasAccessForDelete &&
                <button className={'btn btn-primary btn-outline pull-right ml-3'} onClick={this.delete}>
                  <i className="fa fa-trash"></i>
                  <span className="pl-1">Archive</span>
                </button>
              }
              {hasAccessForEdit &&
                <button className={'btn btn-success btn-outline pull-right'} onClick={this.submit}>
                  <i className="fa fa-check"></i>
                  <span className="pl-1">Save & Continue</span>
                </button>
              }
            </div>

            <form onSubmit={this.submit}>
              <div className="col-12">
                <Input
                  disabled={disableFieldForEdit}
                  field={this.state.fields['sku']}
                  onChange={this.changeFormValue}
                />
                <Input
                  disabled={disableFieldForEdit}
                  field={this.state.fields['name']}
                  onChange={this.changeFormValue}
                />
                <Currency
                  disabled={disableFieldForEdit}
                  field={this.state.fields['cost']}
                  onChange={this.changeFormValue}
                />
                <Currency
                  disabled={disableFieldForEdit}
                  field={this.state.fields['price']}
                  onChange={this.changeFormValue}
                />
                <ReactSelectWrapper
                  disabled={disableFieldForEdit}
                  options={this.getVendorsOptions()}
                  field={this.state.fields['vendor']}
                  onChange={this.changeFormValue}
                />
                <Input
                  disabled={disableFieldForEdit}
                  field={this.state.fields['unit_of_measure']}
                  onChange={this.changeFormValue}
                />
                <TextArea
                  disabled={disableFieldForEdit}
                  field={this.state.fields['notes']}
                  onChange={this.changeFormValue}
                />
              </div>
            </form>
            <ConfirmAction id={'deleteMaterial'} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    redirectToMaterials: () => {
      dispatch(push('/pages/materials'));
    },
    getDataById: (id) => {
      getMaterial(id)(dispatch);
    },
    saveForm: (id, data, remove) => {
      updateMaterial(id, data, remove)(dispatch);
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    },
    getVendors: () => {
      getVendorsList()(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MaterialEdit);



// WEBPACK FOOTER //
// ./src/containers/MaterialEdit/index.js